import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withFirebase } from '../../firebase';
import { faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import uuid from 'react-uuid'
import Switch from "react-switch";
import Loader from 'react-loader-spinner';
import '@lourenci/react-kanban/dist/styles.css'
import { generateGroupBoard } from '../MatchesUtil';
import GroupBoard from '../Board/GroupBoard';
import ModalConfirmCustom from '../../useful/ModalConfirmCustom';

const GroupForm = (props) => {

    const userId = props.firebase.auth.currentUser.uid; // user auth uid
    const { tournament, teams, showModal } = props;

    useEffect(() => {
        selectGroup(2);
    }, [teams])

    const _groups = [];
    let g = 2;
    while (teams.length > 2 * g) {
        _groups.push(g);
        g *= 2;
    }

    const [groups, setGroups] = useState(2);
    const [loading, setloading] = useState(false);
    const [checked, setChecked] = useState(false);
    const [dataBoard, setDataBoard] = useState(null);

    const [confirmShow, setConfirmShow] = useState(false);

    const selectGroup = (g) => {
        const _board = generateGroupBoard(g, teams);
        setGroups(g);
        setDataBoard(_board);
    }

    if (teams.length <= 2 * groups) {
        return (
            <div className="row nav justify-content-center small">
                <span className="col-12 col-md-9 text-secondary font-italic text-center font-italic pt-2">
                    La cantidad de equipos no es suficiente.
                </span>
            </div>
        )
    }

    const onSubmit = () => {
        setConfirmShow(true);
    }

    const generateMatches = () => {
        setConfirmShow(false);
        //check amount of teams > 1
        if (teams.length > (2 * groups)) {

            setloading(true);

            //generate matches...
            try {
                const batch = props.firebase.batch();

                // calculate maximun stages in all groups 
                let maxN = 0;
                dataBoard.columnsId.forEach((columnId) => {
                    const column = dataBoard.columns[columnId];
                    const cards = column.cards;

                    // check that every group has 2 or more teams
                    if (cards.length < 2) {
                        setloading(false)
                        showModal("Error", " Cada grupo debe tener al menos 2 equipos.")
                        return;
                    }
                    maxN = (cards.length > maxN) ? cards.length : maxN;
                });
                maxN = (maxN % 2 === 0) ? maxN - 1 : maxN;

                const matchdayTitle = "Jornada ";
                let groupIndex = 0;

                dataBoard.columnsId.forEach((columnId) => {

                    const column = dataBoard.columns[columnId];
                    const cards = column.cards;

                    // add group id to each team
                    cards.forEach(team => {
                        batch.update(props.firebase.teamDoc(userId, tournament.uid, team.id), { group: { index: groupIndex, title: column.title } });
                    });
                    groupIndex++;

                    // add empty team for uneven teams
                    if (cards.length % 2 != 0) {
                        cards.push(null);
                    }

                    let matchday = 0;
                    let n = cards.length;
                    let k = n - 1;
                    while (k--) {
                        matchday++;
                        let i, j;
                        for (i = 0, j = n - 1; i < j; i++, j--) {

                            let teamA = cards[i];
                            let teamB = cards[j];
                            if (k % 2 === 0) {
                                teamA = cards[j];
                                teamB = cards[i];
                            }

                            if (teamA && teamB) {
                                const match = {
                                    userUid: userId,
                                    tournamentUid: tournament.uid,
                                    teamA: teamA.id,
                                    teamB: teamB.id,
                                    matchday: {
                                        index: matchday,
                                        title: matchdayTitle + matchday
                                    }
                                };
                                batch.set(props.firebase.matchDoc(userId, tournament.uid, uuid()), match);

                                if (checked) {
                                    const match1 = {
                                        userUid: userId,
                                        tournamentUid: tournament.uid,
                                        teamA: teamB.id,
                                        teamB: teamA.id,
                                        matchday: {
                                            index: (matchday + maxN),
                                            title: matchdayTitle + (matchday + maxN)
                                        }
                                    };
                                    batch.set(props.firebase.matchDoc(userId, tournament.uid, uuid()), match1);
                                }
                            }
                        }
                        // rotate keeping firt team 
                        const first = cards.shift();
                        const temp = cards.shift();

                        cards.push(temp)
                        cards.unshift(first);
                    }
                });

                // insert subtype (ida/vuelta)
                let _subType = "Ida";
                if (checked) {
                    _subType = "Ida/Vuelta";
                }
                // set matchesGroupGenerated to tournament item...
                batch.update(props.firebase.tournamentDoc(userId, tournament.uid), { matchesGroupGenerated: true, subType: _subType });

                batch.commit().then(() => {
                    setloading(false);
                }).catch(error => {
                    setloading(false);
                    console.log("Error: ", error);
                    showModal("Error", "Ocurrió un error al generar los partidos. Compruebe los datos e intentelo de nuevo.")
                });
            } catch (error) {
                setloading(false);
                console.log("Error: ", error);
                showModal("Error", "Ocurrió un error al generar los partidos. Compruebe los datos e intentelo de nuevo.")
            }

        } else {
            showModal("Información", "Es necesario tener al menos " + (2 * groups + 1) + " equipos.");
        }

    }

    return (
        <div className="col small" >

            <div className="row nav justify-content-center">
                <span className="col-12 col-md-9 text-secondary font-italic text-center font-italic">
                    Marque si desea generar partidos de ida y vuelta para cada grupo y seleccione la cantidad de grupos que desee. Una ves generado los partidos, los cambios los debrá realizar de forma manual.
                </span>
            </div>

            {!(loading) ?
                <div className="row mt-2">

                    <div className="col-6 p-0 pr-1 nav align-middle justify-content-end">
                        <label className="align-self-center m-0" htmlFor="switch">
                            <span className="mr-1">Ida y vuelta</span>
                            <Switch
                                onChange={(checked) => setChecked(checked)}
                                checked={checked}
                                uncheckedIcon={<p className="small text-white font-weight-bold text-center pt-1">No</p>}
                                checkedIcon={<p className="small text-white font-weight-bold text-center pt-1">Si</p>}
                                onColor="#28a745"
                                offColor="#90a4ae"
                                handleDiameter={16}
                                height={22}
                                width={44}
                                id="switch"
                            />
                        </label>
                    </div>
                    <div className="col-6 p-0 pl-1 nav ">
                        <select value={groups} onChange={(e) => selectGroup(parseInt(e.target.value))} className="form-control form-control-sm pr-4 align-self-center" style={{ width: 'auto' }}>
                            {/* <option value={0}>Seleccionar...</option> */}
                            {_groups.map((item) =>
                                <option key={item} value={item}>{item + " Grupos"}</option>)
                            }
                        </select>
                    </div>



                    <div className="col-12 p-0 nav justify-content-center mt-2">
                        <button onClick={onSubmit} className="col-auto btn btn-sm btn-success m-1">
                            <FontAwesomeIcon className="mr-2" icon={faCheck} />
                            <span>Generar Partidos</span>
                        </button>
                    </div>

                    {(!!dataBoard) ?
                        <GroupBoard setDataBoard={setDataBoard} dataBoard={dataBoard} />
                        :
                        <></>
                    }

                </div>
                :
                <div className="col-12 nav justify-content-center">
                    <Loader className="m-2"
                        type="ThreeDots"
                        color="#263238"
                        height={30}
                        width={60}
                        timeout={0} />
                </div>
            }

            {/* GroupConfirm Modal */}
            <ModalConfirmCustom
                show={confirmShow}
                onClose={() => setConfirmShow(false)}
                onConfirm={generateMatches}
            >
                <p className="card-title font-weight-bolder">Generar Partidos</p>

                <div className="text-black-50 font-italic small mb-3">
                    <FontAwesomeIcon className="text-break mr-1" icon={faExclamationTriangle} />
                    <span>El campo <strong>"Ida y vuelta"</strong> no podrá ser modificado mas adelante.</span>
                </div>

                <div className="text-black-50 font-italic small mb-3">
                    <FontAwesomeIcon className="text-break mr-1" icon={faExclamationTriangle} />
                    <span>La cantidad de grupos no podrá ser modificado mas adelante.</span>
                </div>

                <p className="small card-text text-break">Está seguro que desea generar los partidos?</p>

            </ModalConfirmCustom>

        </div >
    );
}

export default withFirebase(GroupForm);


